import React from 'react';
import {Mail} from "react-feather";
import {Link} from "react-router-dom";

const NavMessaging = ({newMessageCount}) => {

    return (
        <Link to={'/messaging'} className="sl-btn-link-gray sl-p-2-point-5 sl-mr-4 sl-relative">
            <Mail/>
            {newMessageCount > 0 && (
                <span
                    className="sl-flex sl-justify-center sl-align-center sl-absolute sl-top-0 sl-right-0 sl-rounded-full sl-h-5 sl-w-5 sl-bg-error-600 sl-text-white sl-text-xs sl-font-medium">
                    {newMessageCount}
                </span>
            )}
        </Link>
    );
};

export default NavMessaging;
